const tableData = [{
  IMAGE: "https://wsismart.s3.us-west-1.amazonaws.com/Bazla/Bazla-14-100-gi_files/8/0_0.jpeg",
  DOCUMENTTYPE: "Slide Note",
  name: "Bonnie Green",
  GROUP: "Control 10D",
  ANIMAL: "Rat #1",
  OPGAN: "$2300",
  status: "Completed"
},{
  IMAGE: "https://wsismart.s3.us-west-1.amazonaws.com/Bazla/Bazla-14-100-gi_files/8/0_0.jpeg",
  DOCUMENTTYPE: "Payment refund to",
  name: "#00910",
  GROUP: "Control 15D",
  ANIMAL: "Rat #1",
  OPGAN: "$2300",
  status: "Action Needed"
},{
  IMAGE: "https://wsismart.s3.us-west-1.amazonaws.com/Bazla/Bazla-14-100-gi_files/8/0_0.jpeg",
  DOCUMENTTYPE: "Payment failed form",
  name: "#087651",
  GROUP: "High 10D",
  ANIMAL: "Rat #1",
  OPGAN: "$2300",
  status: "Interim Note"
},{
  IMAGE: "https://wsismart.s3.us-west-1.amazonaws.com/Bazla/Bazla-14-100-gi_files/8/0_0.jpeg",
  DOCUMENTTYPE: "Payment form",
  name: "Lana Byrd",
  GROUP: "High 15D",
  ANIMAL: "Rat #1",
  OPGAN: "$2300",
  status: "Completed"
},{
  IMAGE: "https://wsismart.s3.us-west-1.amazonaws.com/Bazla/Bazla-14-100-gi_files/8/0_0.jpeg",
  DOCUMENTTYPE: "Payment form",
  name: "THEMSBERG LLC",
  GROUP: "Low 10D",
  ANIMAL: "Rat #1",
  OPGAN: "$2300",
  status: "Completed"
}];

export default tableData;